import React from "react";
import { useParams } from "react-router-dom";
import { fetchData } from "../api";
import { useQuery } from "react-query";
import Spinner from "../components/Spinner/Spinner";

import BlogPostQuicklink from "../components/BlogPost/BlogPostQuicklink";

function StockInfo() {
  const { id } = useParams();

  const { data, isLoading } = useQuery(["company-info"], () =>
    fetchData("company", id)
  );

  if (isLoading) return <Spinner />;

  return <BlogPostQuicklink ticker={id} meta={data} category="blog" />;
}

export default StockInfo;
